import React from "react";
import Grid from "@mui/material/Grid";
import "../theme/theme.css";
import { Link } from "react-router-dom";

const GooglePlayButton = ({ className }) => (
    <a href="https://play.google.com/store/apps/details?id=cardz.app" target="_blank" rel="noreferrer" className={className}>
      <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
           alt="Get it on Google Play" height="60" />
    </a>
);

const AppStoreButton = ({ className }) => (
    <a href="https://apps.apple.com" target="_blank" rel="noreferrer" className={className}>
      <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
           alt="Download on the App Store" height="60" />
    </a>
);

function Footer() {
  const current = new Date();
  const date = `${current.getFullYear()}`;

  return (
    <div>
      <Grid container direction="column" className="footerContainer">
        <div className="footerButtonContainer">
          <Grid item xs={12} className="footerButton">
            <GooglePlayButton
              className={"custom-style"}
            />
            <AppStoreButton
              theme={"dark"}
              className={"appstoreButton"}
            />
          </Grid>
        </div>
        <Grid item>
          <div className="privacyStatement">
            <Link to="/privacy-statement" className="footerLink">Privacy statement</Link>
          </div>
        </Grid>
        <Grid item>
          <div className="footerDesignBy">
            <p>Copyrights © {date}. Designed by Tim Lokers</p>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default Footer;
